import { ignoreSSRWarning } from '@sales-center/common'
import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const SectionHeading = styled(Typography, {
  name: 'SectionHeading',
  slot: 'Root',
  skipSx: false,
})(
  ({ theme }) => `
  color: ${theme.palette.text.primary};
  font-family: 'Source Sans Pro';
  font-size: 15px;
  &:not(:first-child) ${ignoreSSRWarning} {
    margin-top: 24px;
  }
`,
)
